"use client";

import { useState } from "react";
import { faqs } from "@/data/faqs";

function FAQSchemaScript() {
  const data = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-surface">
      <FAQSchemaScript />
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="section-badge mb-4 mx-auto">FAQ</p>
          <h2 className="text-2xl sm:text-3xl md:text-[48px] font-bold leading-[1.2] font-ui">
            <span>Your Questions </span>
            <span className="font-serif italic text-purple-light">Answered</span>
          </h2>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-card-border rounded-xl overflow-hidden hover:border-foreground/10 transition-colors">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between p-4 sm:p-5 text-left"
              >
                <span className="text-sm font-medium text-foreground/80 pr-4">{faq.question}</span>
                <span className={`w-7 h-7 rounded-full border flex-shrink-0 flex items-center justify-center transition-all duration-300 ${
                  openIndex === i ? "border-[#E11D24] bg-[#E11D24]/10 rotate-180" : "border-foreground/15"
                }`}>
                  <svg
                    className={`w-3.5 h-3.5 transition-colors ${openIndex === i ? "text-[#E11D24]" : "text-foreground/30"}`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? "max-h-96 pb-5" : "max-h-0"
                }`}
              >
                <p className="text-xs text-foreground/40 font-body leading-relaxed px-4 sm:px-5">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
